import React from 'react';
import ReactApexChart from 'react-apexcharts';
import { ApexOptions } from 'apexcharts';

interface SimpleBarGraphProps {
  xAxisOptions: ApexOptions['xaxis'];
  yAxisData: number[];
  graphWidth?: number | string;
  graphHeight?: number;
  showGrid?: boolean;
  colors?: string[];
  tickAmount?: number;
}

export default function SimpleBarGraph({
  xAxisOptions,
  yAxisData,
  graphWidth = 1000,
  graphHeight = 450,
  showGrid = true,
  colors = ['#8B8296'],
  tickAmount,
}: SimpleBarGraphProps) {
  const options: ApexOptions = {
    colors,
    fill: {
      opacity: 1,
    },
    plotOptions: {
      bar: {
        columnWidth: '100%',
        distributed: true,
      },
    },
    dataLabels: {
      enabled: false,
    },
    legend: {
      show: false,
    },
    xaxis: xAxisOptions,
    yaxis: {
      axisBorder: {
        show: false,
      },
      axisTicks: {
        show: false,
      },
      tickAmount,
    },
    grid: {
      show: showGrid,
    },
    chart: {
      animations: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
      zoom: {
        enabled: false,
      },
    },
  };

  const series = [
    {
      data: yAxisData,
    },
  ];

  return (
    <div style={{ width: '100%', overflow: 'hidden' }}>
      <ReactApexChart
        options={options}
        series={series}
        type="bar"
        height={graphHeight}
        width={typeof graphWidth === 'string' ? graphWidth : graphWidth}
      />
    </div>
  );
}
